import React from "react";
import { Stack, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import ToggleSwitch from "./input-elements/ToggleSwitch";
import CurrencyInput from "./input-elements/CurrencyInput";

const useStyles = makeStyles({
    root: {
        height: 48,
        "& .MuiTextField-root": {
            width: "40%",
        },
    },
});

function CancellationFee(props) {
    const {
        handleToggleChange,
        handleInputChange,
        title,
        toggleValue,
        inputValue,
        options,
        errors,
        className = "input-wrapper",
    } = props;
    const classes = useStyles();
    return (
        <Stack class={className}>
            <Typography class="title">{title}</Typography>
            <Stack
                direction={{ xs: "column", sm: "row" }}
                spacing={{ xs: 2, sm: 1 }}
                className={classes.root}
            >
                <ToggleSwitch
                    handleChange={handleToggleChange}
                    value={toggleValue}
                    options={options}
                />
                {toggleValue == "yes" && (
                    <CurrencyInput
                        label="Reimbursement Maximum"
                        placeholder="300"
                        name="reimbursement_maximum"
                        type="number"
                        onChange={handleInputChange}
                        value={inputValue}
                        errors={errors}
                    />
                )}
            </Stack>
        </Stack>
    );
}

export default CancellationFee;
